import * as SockJS from 'sockjs-client'
import { CompatClient, Stomp } from '@stomp/stompjs'

class WebSocketService {
   stompClient = /** @type {CompatClient | null} */ (null)

   constructor() {
      // Singleton
      if (!WebSocketService.stompClient) {
         WebSocketService.stompClient = this
      }
      return WebSocketService.stompClient
   }

   static getInstance() {
      return this.stompClient
   }

   connect(socketUrl, tokenApp, userEmail, onGetNotification, onGetRegulation) {
      const socket = new SockJS(socketUrl)
      this.stompClient = Stomp.over(socket)
      this.stompClient.connect(
         { 'X-Authorization': `Bearer ${tokenApp}` },
         frame => {
            this.stompClient.subscribe(
               `/user/${userEmail}/topic/notifications`,
               message => onGetNotification(JSON.parse(message.body))
            )
            this.stompClient.subscribe(
               `/user/${userEmail}/topic/circulars`,
               message => onGetRegulation(JSON.parse(message.body))
            )
         }
      )
   }

   disconnect() {
      if (this.stompClient !== null) {
         this.stompClient.disconnect()
      }
   }
}

export default WebSocketService